import { createAPI } from '../../common'

export default {
    //查询专家信息
    getExpertByMemberId: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0fyqfsu0hfuFyqfsuCzNfncfsJe', 'get', config),
    // 获取字段设置
    getFields: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0fyqfsu0gjfmet', 'get', config),
    //保存专家
    postExpert: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0fyqfsu0tbwf', 'post', config),
    // 专家独立入口-作品列表
    getWorkList: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0tfmfdujpo0xpsltMjtu', 'get', config),
    // 获取图片
    getImageUrl: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0hfuJnbhfVsm', 'get', config),
    //作品评审详情
    getReviewDetail: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0tfmfdujpo0xpslt0sfwjfx0efubjm', 'get', config),
    //下载接口
    getArticleLink:
        (config) =>
            createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0bsujdmf0gjmft0mjol', 'get', config),
    //作品评审保存
    postReviewSave: (config) =>
        createAPI('customEncryptApiName-1/0qsfcbunbo0cbunbo0tfmfdujpo0xpslt0sfwjfx', 'post', config),

}
